<template>
  <g>
    <path
        d="M26.111 26V24C26.111 22.9391 25.6709 21.9217 24.8874 21.1716C24.1039 20.4214 23.0413 20 21.9332 20H13.5777C12.4697 20 11.407 20.4214 10.6235 21.1716C9.84006 21.9217 9.3999 22.9391 9.3999 24V26"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
    <path
        d="M17.7554 16C20.0627 16 21.9332 14.2091 21.9332 12C21.9332 9.79086 20.0627 8 17.7554 8C15.4481 8 13.5776 9.79086 13.5776 12C13.5776 14.2091 15.4481 16 17.7554 16Z"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
  </g>
</template>